import React from 'react';
import classNames from 'classnames';
import InputElement from '../InputElement/InputElement';

import css from './InputSearch.module.css';

export interface InputSearchProps {
  className?: string;
  classNameContainer?: string;
  classNameButtonClose?: string;
  classNameButtonMagnifier?: string;
  classNameInputField?: string;
  
  // tslint:disable-next-line: no-any
  setRef?: (node: any) => HTMLDivElement;
  
  onCloseButton?: (e?: React.MouseEvent<{}>) => void;
  onEnterKeyPress?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onMagnifyClick?: (e?: React.MouseEvent<{}>) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  
  placeholderTranslation: string;
  autoFocus?: boolean;
  value?: string;
}

interface InputSearchState {
  isFilled: boolean;
}

class InputSearch extends React.Component<InputSearchProps, InputSearchState> {
  inputSearchRef!: React.RefObject<HTMLInputElement>;
  
  constructor(props: InputSearchProps) {
    super(props);
    
    this.handleMagnifyClick = this.handleMagnifyClick.bind(this);
    this.handleOnKeyPress = this.handleOnKeyPress.bind(this);
    this.handleOnCloseButtonClick = this.handleOnCloseButtonClick.bind(this);
    
    this.focusSearchInput = this.focusSearchInput.bind(this);
    
    this.inputSearchRef = React.createRef<HTMLInputElement>();
    this.state = {isFilled: !!props.value};
  }
  
  handleMagnifyClick() {
    this.focusSearchInput();
    
    if (this.props.onMagnifyClick) {
      this.props.onMagnifyClick();
    }
  }
  
  handleOnKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
    if (e && e.key === 'Enter') {
      // this.props.onEnterKeyPress(e);
    }
  }
  
  handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
    if(this.inputSearchRef.current) {
      this.setState({isFilled: !!this.inputSearchRef.current.value});
    }
    
    if (this.props.onChange) {
      this.props.onChange(e);
    }
  }
  
  handleOnCloseButtonClick() {
    if (this.inputSearchRef.current) {
      this.inputSearchRef.current.value = '';
      this.setState({isFilled: false});
      this.inputSearchRef.current.focus();
    }
  
    if (this.props.onCloseButton) {
      this.props.onCloseButton();
    }
  }
  
  focusSearchInput() {
    if(this.inputSearchRef.current) {
      this.inputSearchRef.current.focus();
    }
  }
  
  render() {
    const {
      className,
      classNameContainer,
      classNameButtonClose,
      classNameButtonMagnifier,
      classNameInputField,
      setRef,
      placeholderTranslation
    } = this.props;
    
    const InputSearchClasses = classNames(
      css.InputSearch,
      this.state.isFilled && css.isFilled,
      className
    );
    
    return (
      <div className={InputSearchClasses} ref={setRef}>
        <div className={classNames(css.searchBox, classNameContainer)}>
          <button
            className={classNames(css.buttonMagnifier, classNameButtonMagnifier)}
            onClick={this.handleMagnifyClick}
          >
            <i className={classNames(css.iconSearch, "iconSearch")}/>
          </button>
          <InputElement
            type="search"
            inputRef={this.inputSearchRef}
            placeholder={placeholderTranslation}
            className={classNames(css.input, classNameInputField)}
            onKeyPress={(e) => this.handleOnKeyPress(e)}
            onChange={(e) => this.handleOnChange(e)}
            autoFocus={this.props.autoFocus}
            value={this.props.value}
          />
          <button
            className={classNames(css.buttonClose, this.state.isFilled && css.isFilled, classNameButtonClose)}
            onClick={this.handleOnCloseButtonClick}
          >
            <i className={classNames(css.iconCross, "iconCross")}/>
          </button>
        </div>
      </div>
    );
  }
}

export default InputSearch;
